import React from 'react';
import { getMarkDown } from '../utils';
import Footer from './Footer';
import '../../../stylesheets/triagebot/Text.scss';

const GenderCardMessage = ({ message, sendMessage, }) => {

    return (
        <div
            className='textcard card'
        >
            <div className='header'>
                <h2 className='headerText'>{getMarkDown(message)}</h2>
            </div>
            <div className='body' style={{ height: 120 }}>
                [Deprecated] Please update to prompt.
            </div>
            <Footer>
                <button
                    className={'submit-button'}
                    onClick={() => sendMessage('message', 'male', 'male')}
                >
                    Male
                </button>
                <button
                    className={'submit-button'}
                    onClick={() => sendMessage('message', 'female', 'female')}
                >
                    Female
                </button>                
            </Footer>            
        </div>
    );

};

export default GenderCardMessage;
